/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userOffers.internal

import features.userOffers.models.UserOffersModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.userOffers.internal.UserOffersUseCase.Params

internal class UserOffersUseCase : AsyncUseCase<UserOffersModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,

    )

    private val userOffersService: UserOffersService = UserOffersServiceImpl()

    override suspend fun run(params: Params): Result<UserOffersModel> {
        return userOffersService.getUserOffers(
            overrideHeaders = params.overrideHeaders,

        )
    }
}
